/**
 * Created by fers on 27/08/2017.
 */

import React from 'react';
import PropTypes from 'prop-types';
import './Expression.scss';

import {expressionBuilder, Builder} from '../../common/expression/ExpressionBuilder';

export class VisualBuilder extends Builder {

    constructor(expressionGroup) {
        super();

        this.expressionGroup = expressionGroup;
    }

    onOperator(operator, children) {
        let result = [];

        let idx = 0;
        for (let child of children) {
            if (idx > 0) {
                result.push(<span key={idx + "-operator"}> {operator} </span>);
            }
            result.push(<span key={idx}>{child}</span>);
            idx++;
        }

        return (<span>{result}</span>);
    }

    onVariable(variable) {
        if (!this.expressionGroup) {
            return <code>{variable}</code>;
        }

        let groups = this.expressionGroup.props.possibleVariableGroups();
        let possibleVariables = this.expressionGroup.props.possibleVariables(groups[0]);

        let field = possibleVariables.find((v) => v.realId === variable || v.key === variable);

        if (field) {
            return <code>{field.name}</code>;
        } else {
            return <code>{variable}</code>;
        }
    }

    onFunction(funcName, args) {
        let result = [];

        let idx = 0;
        for (let child of args) {
            if (idx > 0) {
                result.push(<span key={idx + "-operator"}>, </span>);
            }
            result.push(<span key={idx}>{child}</span>);
            idx++;
        }

        return (<span className="expression-func"><span className="tag">{funcName}</span>{"("}{result}{")"}</span>);
    }

    onLogicalExpression(expr1, operator, expr2) {
        return this.onOperator(operator, [expr1, expr2]);
    }

    onConditional(condition, expr1, expr2) {
        return (<span className="expression-func"><span className="tag">{condition}</span> ? <span className="tag">{expr1}</span> : <span className="tag">{expr2}</span></span>);
    }

    onLambda(variable, expr1) {
        return (<span className="expression-func">(<span className="tag">{variable}</span>){" => "}<span className="tag">{expr1}</span></span>);
    }

    onValue(value) {
        return <span>{value}</span>;
    }

    onBracket(child) {
        return (<span>{"("}{child}{")"}</span>);
    }

    onText(text) {
        return text;
    }

    onExpression(expression) {
        return (<span className="expression-all">{expression}</span>);
    }
}

interface ExpressionProps {
    afterChange?: (...args: unknown[]) => unknown;
    allowEditing?: boolean;
    expression?: string;
    multiLine?: boolean;
    onChange?: (...args: unknown[]) => unknown;
}

export default class Expression extends React.Component<ExpressionProps> {

    static propTypes = {
        afterChange: PropTypes.func,
        allowEditing: PropTypes.bool,
        expression: PropTypes.string,
        multiLine: PropTypes.bool,
        onChange: PropTypes.func,
    };

    static contextTypes = {
        expressionGroup: PropTypes.object,
    };

    static defaultProps = {
        allowEditing: true,
    };

    constructor(props) {
        super(props);

        this.state = {
            isEditing: false,
            expression: props.expression,
        };
    }

    onClick = () => {
        if (this.state.isEditing === false && this.props.allowEditing) {
            this.setState({
                "isEditing": true
            });
        }
    };

    onBlur = () => {
        this.setState({
            "isEditing": false
        });

        if (this.props.afterChange) {
            this.props.afterChange(this.state.expression);
        }
    };

    onChange = (event) => {
        this.setState({
            expression: event.target.value
        });

        if (this.props.onChange) {
            this.props.onChange(event.target.value);
        }

        return true;
    };

    render() {
        if (this.props.multiLine) {
            return <div className="expression-edit"><textarea autoFocus onBlur={this.onBlur} onChange={this.onChange} value={this.state.expression} /></div>;
        }
        if (this.state.isEditing) {
            return (
                <div className="expression-edit"><input autoFocus onBlur={this.onBlur} onChange={this.onChange} value={this.state.expression} /></div>
            );
        } else {
            try {
                let result = expressionBuilder(this.state.expression, new VisualBuilder(this.context.expressionGroup));
                if (this.props.allowEditing) {
                    return <div className="expression-edit-fake" onClick={this.onClick}>{result}</div>;
                } else {
                    return <div>{result}</div>;
                }
            } catch (e) {
                return <div className="expression-edit-fake" onClick={this.onClick}>{this.state.expression}</div>;
            }
        }
    }
}
